import { Component } from '@angular/core';

@Component({
  selector: 'bu-navbar-brand',
  template: `<ng-content></ng-content>`
})
export class BuNavbarBrandComponent {}
